import { render, staticRenderFns } from "./VipPriceTab.vue?vue&type=template&id=440f5029&"
import script from "./VipPriceTab.ts?vue&type=script&lang=js&"
export * from "./VipPriceTab.ts?vue&type=script&lang=js&"
import style0 from "./VipPriceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports